import useEventCallback from './useEventCallback';

export default useEventCallback;
